module.exports = __webpack_public_path__ + "img/home.0a70cad3.svg";